import ReceiptForm from "../../components/ReceiptComponents/ReceiptForm";

function NewReceiptPage() {
  return <ReceiptForm method="post" title="Receipt" />;
}

export default NewReceiptPage;

